import React from "react";
import "./WorkingProcess.css";

const WorkingProcess = () => {
  return (
    <section className="troo-da-stages-section" id="troo-da-stages-section">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="sub-txt">
              <span>Installation Stages</span>
              <h2>
                Our Working Process For
                <br /> The Most Accurate Energy.
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="installation-stages">
              <div className="stag-one">
                <div className="ins-text">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been.
                  </p>
                </div>
                <div className="ins-num">01</div>
              </div>
              <div className="ins-bt">
                <div className="ans-border ans-bottom"></div>
                <div className="ins-tile">Analysis</div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="installation-stages btn-bttom">
              <div className="ins-bt">
                <div className="ins-num">02</div>
                <div className="ins-tile">Planning</div>
                <div className="ans-border ans-bottom"></div>
              </div>
              <div className="stag-one">
                <div className="ins-text">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="installation-stages">
              <div className="stag-one">
                <div className="ins-text">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been.
                  </p>
                </div>
                <div className="ins-num">03</div>
              </div>
              <div className="ins-bt">
                <div className="ans-border ans-bottom"></div>
                <div className="ins-tile">Calculation</div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="installation-stages btn-bttom">
              <div className="ins-bt">
                <div className="ins-num">04</div>
                <div className="ins-tile">Application</div>
                <div className="ans-border ans-bottom"></div>
              </div>
              <div className="stag-one">
                <div className="ins-text">
                  <p>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkingProcess;
